<template>
  <div>
    <b-card v-if="usuarioAdmin || usuarioTecnico">
      <div slot="header">
        <strong>Registro de Productos Químicos</strong>
      </div>
      <b-card-body>

          <b-row class="d-flex">
            <b-col sm="6">
              <b-form-group label="Empresa" horizontal="">
                <el-select
                  v-model="selectedInventario.empresa"
                  @change="cargarUbicaciones(selectedInventario.empresa)"
                  filterable
                  remote
                  clearable
                  no-data-text="No hay datos que coincidan"
                  no-match-text="No hay datos que coincidan"
                  :remote-method="buscarEmpresa"
                >
                  <el-option
                    v-for="item in listaEmpresas"
                    :key="item.id"
                    :label="item.nombre"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </b-form-group>
              <span v-if="errors" style="color: red"
                >* La empresa es Obligatoria</span
              >
            </b-col>

            <b-col sm="6">
              <b-form-group>
                <label for="bases">Ubicaciones</label>
                <treeselect
                  :value="val"
                  :multiple="true"
                  :options="ubicEmpresa"
                  :defaultExpandLevel="Infinity"
                  :normalizer="your_normalizer"
                  value-consists-of="ALL_WITH_INDETERMINATE"
                  @input="setFiltroUbicacion"
                  :disabled="!selectedInventario.empresa"
                />
              </b-form-group>
            </b-col>

            <b-col
              sm="6"
              v-if="contratistas.length && selectedInventario.empresa && !usuarioEmpresaContratista"
            >
              <label for="bases">Empresa contratista</label>
              <el-select
                @change="watchContrarista()"
                v-model="selectedInventario.contratista"
                :disabled="!selectedInventario.empresa"
                filterable
                remote
                clearable
                no-data-text="No hay datos que coincidan"
                no-match-text="No hay datos que coincidan"
              >
                <el-option
                  v-for="item in contratistas"
                  :key="item.id"
                  :label="item.nombre"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </b-col>

            <b-col sm="6" v-if="selectedInventario.empresa">
              <b-form-group>
                <label for="bases">Tipo de reporte</label>
                <el-select
                  v-model="tipoInventario"
                  filterable
                  remote
                  clearable
                  no-data-text="No hay datos que coincidan"
                  no-match-text="No hay datos que coincidan"
                >
                  <el-option
                    v-for="item in tiposReporteAdmin"
                    :key="item"
                    :label="item.replace(/([a-z])([A-Z])/g, '$1 $2')"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </b-form-group>
            </b-col>

            <b-col sm="6" v-if="tipoInventario === 'FdsVencidas'">
              <b-form-group label="Fecha" horizontal>
                <el-date-picker
                  v-model="selectedInventario.fecha"
                  type="daterange"
                  name="fecha_despues"
                  id="fecha_despues"
                  class="w-100"
                  value-format="yyyy-MM-dd"
                  format="yyyy-MM-dd"
                  range-separator="a"
                  start-placeholder="Fecha inicio"
                  end-placeholder="Fecha fin"
                />
              </b-form-group>
            </b-col>
            <b-col sm="6" class="d-flex">
              <b-form-checkbox v-model="selectedInventario.mys" value="1">
                Reporte MyS
              </b-form-checkbox>
            </b-col>
          </b-row>

          <b-row class="d-flex mt-2">
            <b-col sm="6" md="auto" class="d-flex">
              <button
                class="btn btn-info btn-block my-1"
                @click="mostrarReportes(true)"
              >
                Consultar reportes agendados
              </button>
            </b-col>

            <b-col sm="6" md="auto" class="d-flex">
              <button
                class="btn btn-primary btn-block my-1"
                v-if="tipoInventario === 'Total'"
                @click="invTot('Total')"
                :disabled="!tipoInventario"
              >
                Crear reporte
              </button>
              <button
                class="btn btn-primary btn-block my-1"
                v-else
                @click="Inventario(tipoInventario)"
                 :disabled="!tipoInventario || (tipoInventario==='FdsVencidas' && !selectedInventario.fecha)"
              >
                Crear reporte
              </button>
            </b-col>
          </b-row>

      </b-card-body>
    </b-card>

    <b-card v-else>

        <b-row class="d-flex" v-if="!usuarioEmpresaContratista">
          <b-col lg="6">
            <b-form-group>
              <label for="bases">Ubicaciones</label>
              <treeselect
                :value="val"
                :multiple="true"
                :defaultExpandLevel="Infinity"
                :options="ubicEmpresa"
                value-consists-of="ALL_WITH_INDETERMINATE"
                @input="setFiltroUbicacion"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="d-flex" v-else>
          <b-col lg="6">
            <b-form-group label="Empresa contratante" horizontal="">
              <el-select
                v-model="selectedInventario.empresa"
                @change="cargarUbicaciones(selectedInventario.empresa)"
                filterable
                remote
                clearable
                no-data-text="No hay datos que coincidan"
                no-match-text="No hay datos que coincidan"
                :remote-method="buscarEmpresa"
              >
                <el-option
                  v-for="item in listaEmpresas"
                  :key="item.id"
                  :label="item.nombre"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </b-form-group>
            <span v-if="errors" style="color: red"
              >* La empresa es Obligatoria</span
            >
          </b-col>

          <b-col lg="6" v-if="!usuarioEmpresaContratista && contratistas.length">
            <b-form-group label="Empresa contratista" horizontal="">
              <el-select
                v-model="selectedInventario.contratista"
                filterable
                remote
                no-data-text="No hay datos que coincidan"
                no-match-text="No hay datos que coincidan"
              >
                <el-option
                  v-for="item in contratistas"
                  :key="item.id"
                  :label="item.nombre"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </b-form-group>
          </b-col>

          <b-col sm="6">
            <b-form-group>
              <label for="bases">Tipo de reporte</label>
              <el-select
                v-model="tipoInventario"
                filterable
                remote
                clearable
                no-data-text="No hay datos que coincidan"
                no-match-text="No hay datos que coincidan"
              >
                <el-option
                  v-if="
                    usuarioEmpresaContratista ||
                    (!usuarioEmpresaContratista &&
                      contratistas.length &&
                      selectedInventario.contratista)
                  "
                  key="Contratista"
                  label="Contratista"
                  value="Contratista"
                >
                </el-option>

                <el-option
                  v-if="!usuarioEmpresaContratista"
                  key="General"
                  label="General"
                  value="General"
                >
                </el-option>

                <el-option
                  v-if="!usuarioEmpresaContratista"
                  key="Cancerigenos"
                  label="Cancerigenos"
                  value="Cancerigenos"
                >
                </el-option>

                <el-option
                  v-if="!usuarioEmpresaContratista"
                  key="IdentificacionPeligros"
                  label="Identificacion de Peligros a la Salud"
                  value="IdentificacionPeligros"
                >
                </el-option>

                <el-option
                  v-if="!usuarioEmpresaContratista"
                  key="Neurotoxicos"
                  label="Neurotoxicos"
                  value="Neurotoxicos"
                >
                </el-option>

                <el-option
                  v-if="!usuarioEmpresaContratista"
                  key="Ototoxicos"
                  label="Ototoxicos"
                  value="Ototoxicos"
                >
                </el-option>

                <el-option
                  v-if="!usuarioEmpresaContratista"
                  key="Propiedades"
                  label="Propiedades"
                  value="Propiedades"
                >
                </el-option>

                <el-option
                  v-if="!usuarioEmpresaContratista"
                  key="SustanciasControladas"
                  label="Sustancias controladas"
                  value="SustanciasControladas"
                >
                </el-option>

                <el-option
                  key="FdsVencidas"
                  label="Vencimiento de FDS"
                  value="FdsVencidas"
                >
                </el-option>
              </el-select>
            </b-form-group>
            <b-modal ref="downloadingModal" hide-footer title="">
              <center>
                <i class="fa fa-spinner fa-spin fa-lg mt-6"></i>
                Descargando, por favor espere
              </center>
              <span style="color: red">
                <center>
                  Habilite las ventanas emergentes en su navegador
                </center>
              </span>
            </b-modal>
          </b-col>

          <b-col sm="6" v-if="tipoInventario === 'FdsVencidas'">
              <b-form-group label="Fecha" horizontal>
                <el-date-picker
                  v-model="selectedInventario.fecha"
                  type="daterange"
                  name="fecha_despues"
                  id="fecha_despues"
                  class="w-100"
                  value-format="yyyy-MM-dd"
                  format="yyyy-MM-dd"
                  range-separator="a"
                  start-placeholder="Fecha inicio"
                  end-placeholder="Fecha fin"
                />
              </b-form-group>
            </b-col>

        </b-row>


      <b-row class="d-flex">
        <b-col sm="6" class="d-flex">
          <b-button
            variant="primary"
            @click="Inventario(tipoInventario)"
            :disabled="!tipoInventario || (tipoInventario==='FdsVencidas' && !selectedInventario.fecha)"
          >
            Crear reporte
          </b-button>
        </b-col>
      </b-row>
    </b-card>
    <b-modal
      class="modal"
      hide-footer
      v-model="modalReportes"
      size="xl"
      :title="'Reportes agendados'"
    >
      <inventariosAgendados
        :inventarios="inventariosProcesados"
      ></inventariosAgendados>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import {getAcls, validarPermisoComponente} from '../../plugins/acl';
import { validarRol} from '../../plugins/acl';
import loader from "../../containers/loader";
import Treeselect from "@riophae/vue-treeselect";
import inventariosAgendados from "./inventariosAgendados.vue";
import { resetSelectedInventario } from "../../servicios/reportes/inventario/mutations";

export default {
  name: "Inventario",
  data: function () {
    return {
      usuarioAdmin: false,
      usuarioAdmin: false,
      usuarioTecnico: false,
      usuarioEmpresaContratista: false,
      FdsVencidas: false,
      esAdmin: false,
      esEmpresa: false,
      esEmpresaContratista: false,
      rol: "",
      permisos: [],
      FdsVencidas: true,
      loading: true,
      errors: false,
      empresasCargadas: false,
      val: null,
      acls: "",
      modalReportes: false,
      tipoInventario: null,
      tiposReporteAdmin: [
        "Completo",
        "General",
        "Cancerigenos",
        "IdentificacionPeligros",
        "Neurotoxicos",
        "Ototoxicos",
        "Propiedades",
        "SustanciasControladas",
        "Reprotoxicos",
        "Teratogenicos",
        "Mutagenicos",
        "MedioAmbiente",
      ],
    };
  },
  components: {
    loader,
    Treeselect,
    inventariosAgendados,
  },
  async created() {
    this.resetSelectedInventario();
    this.validarPermisos();

    this.acls = getAcls();
    this.rol = this.acls.roles.toString();
    this.permisos = this.acls.permisos;
    this.permisos.forEach((element) => {
      if (element == "adm_productos/reportes/fds") {
        this.FdsVencidas = true;
        this.tiposReporteAdmin.push("FdsVencidas");
      }
    });

    this.limpiaEmpresa();

    if (
      this.rol == "admin" ||
      this.rol == "superadmin" ||
      this.rol == "admin-tecnico"
    ) {
      this.usuarioAdmin = true;
      this.tiposReporteAdmin.push("Total");
    } else {
      this.esEmpresa = true;
      if (this.rol === "empresa-contratista") {
        this.esEmpresaContratista = true;
      }
    }

    if (this.esEmpresa) {
      this.selectedInventario.empresa = "";
      if (!this.esEmpresaContratista) {
        this.selectedInventario.empresa = this.acls.empresa;
      }
      await this.listarUbicacionesEmpresa(this.acls.empresa);
    }
    this.load(true);
    await this.listarContratistas();

    this.load(false);
  },
  methods: {
    validarPermisos() {
      this.usuarioAdmin              = validarRol('superadmin') || validarRol('admin');
      this.usuarioTecnico            = validarRol('admin-tecnico');
      this.usuarioEmpresaContratista = validarRol('empresa-contratista');
      this.FdsVencidas               = validarPermisoComponente('visualizar-reporte-fds');
    },
    your_normalizer(node) {
      return {
        children: node.children && node.children.length ? node.children : 0,
      };
    },
    async mostrarReportes(boolean) {
      this.load(true);
      await this.listarInventariosAgendados();
      this.load(false);
      if (boolean === true) {
        this.modalReportes = true;
      }
    },
    async obtenerEmpresasFiltro() {
      this.load(true);
      await this.getEmpresaFiltroInventario();
      this.load(false);
    },
    async cargarUbicaciones(id) {
      this.load(true);
      if (id) {
        await this.listarUbicacionesEmpresa(id);
        this.load(true);
        await this.listarContratistas();
        this.load(false);
      }
      this.load(false);
    },
    ...mapActions("productos", [
      "getEmpresaFiltro",
      "getEmpresaFiltroInventario",
    ]),
    ...mapActions("Reporteinventario", [
      "agendarInventario",
      "descargarInventario",
      "listarInventariosAgendados",
      "listarEmpresas",
      "getBases",
      "getAreas",
      "listarUbicacionesEmpresa",
      "listarContratistas",
      "getEmpresas",
    ]),
    ...mapMutations("Reporteinventario", [
      "setInventario",
      "limpiaEmpresa",
      "setFiltroUbicacion",
      "setUuid",
      "resetSelectedInventario",
      "setReporteMys",
    ]),
    ...mapMutations("dashboard", ["load"]),
    async buscarEmpresa(nombre) {
      if (nombre.length >= 3) {
        let data = { nombre: nombre };
        this.load(true);
        await this.getEmpresas(data);
        this.load(false);
      }
    },
    async Inventario(tipo) {
      this.errors = false;
      if (!this.selectedInventario.empresa) {
        this.errors = true;
      }
      if (!this.errors) {
        if (tipo === "Propiedades") {
          this.setReporteMys({ mys: 1 });
        }
        this.setUuid();
        this.load(true);
        await this.agendarInventario(tipo);
        await this.listarInventariosAgendados();
        this.modalReportes = true;
        this.load(false);
      }
    },
    async invTot(tipo) {
      this.setUuid();
      this.load(true);
      await this.agendarInventario(tipo);
      await this.listarInventariosAgendados();
      this.modalReportes = true;
      this.load(false);
    },
    async DescargarArchivo(adj) {
      window.open(process.env.VUE_APP_API_URL + adj);
      this.$refs.downloadingModal.hide();
    },
    watchContrarista() {
      if (this.selectedInventario.contratista) {
        this.tiposReporteAdmin.push("Contratista");
      } else {
        this.tiposReporteAdmin = this.tiposReporteAdmin.filter(function (item) {
          return item !== "Contratista";
        });
      }
    },
  },
  computed: {
    ...mapState("Reporteinventario", [
      "inventariosProcesados",
      "selectedInventario",
      "optempresa",
      "optbases",
      "optareas",
      "inventario",
      "descargaInventario",
      "ubicEmpresa",
      "contratistas",
      "listaEmpresas",
    ]),
    ...mapState("productos", ["selectedEmpresasInventario", "empresas"]),
  },
};
</script>

<style src="@riophae/vue-treeselect/dist/vue-treeselect.min.css"></style>

<style>
.el-select .el-input .el-select__caret {
  color: #333435;
  font-size: 16px;
  margin-top: 2px;
}

@media (min-width: 576px) and (max-width: 991px) {
  .modal-dialog {
    max-width: 90%;
  }
}
</style>

